/* Public read-only schedule. No owner credentials, storage or customer data. */
(() => {
  'use strict';
  const node=document.getElementById('KobColourArrivalConfig');
  if(!node)return;
  let config;try{config=JSON.parse(node.textContent);}catch{return;}
  if(config.mode!=='managed')return;
  const endpoint=config.policy_url;
  let timer=0,expiryTimer=0,busy=false,version=0,boundaryAt=Infinity,onBoundary=null,policy={stage:'off'},resolve;
  const ready=new Promise(r=>{resolve=r;});
  if(new URLSearchParams(location.search).get('kob_colour_preview')==='1'){
    window.KobStorefrontColourPolicy={ready:Promise.resolve({stage:'off'}),refresh(){}};
    return;
  }
  function valid(value){
    if(!value?.ok||value.schema!==1||!['off','effect','hold'].includes(value.stage)||!Number.isSafeInteger(value.revision))return false;
    if(!Number.isFinite(Date.parse(value.server_time)))return false;
    if(value.ends_at&&!Number.isFinite(Date.parse(value.ends_at)))return false;
    if(value.stage==='off')return true;
    return value.ends_at&&Date.parse(value.ends_at)>Date.parse(value.server_time)&&
      (!value.palette_ends_at || Date.parse(value.palette_ends_at)>=Date.parse(value.ends_at))&&
      (value.banner_material===undefined||['solid','blue-carbon'].includes(value.banner_material))&&
      (value.logo_monochrome===undefined||typeof value.logo_monochrome==='boolean')&&
      Number.isFinite(value.seconds)&&value.seconds>=8.4&&value.seconds<=30&&
      ['light','dark','ink','lilium','accent','logo'].every(k=>/^#[a-f\d]{6}$/i.test(value.palette?.[k]||''));
  }
  function announce(next){
    policy=next;version++;
    window.dispatchEvent(new CustomEvent('kob:colour-policy',{detail:next}));
    resolve(next);
  }
  function plan(value,elapsed=0){
    clearTimeout(timer);clearTimeout(expiryTimer);
    boundaryAt=Infinity;onBoundary=null;
    timer=setTimeout(refresh,60000);
    if(!value.ends_at)return;
    const remaining=Date.parse(value.ends_at)-Date.parse(value.server_time)-elapsed;
    const startedPlan=performance.now();boundaryAt=startedPlan+remaining;
    // Keep an independent deadline while polling. A stalled request cannot
    // cancel the automatic return to the original theme.
    onBoundary=()=>{
      const overdue=Math.max(0,performance.now()-boundaryAt);
      const hold=Date.parse(value.palette_ends_at)-Date.parse(value.ends_at)>overdue&&value.stage==='effect';
      const next=hold?{...value,stage:'hold',server_time:value.ends_at,ends_at:value.palette_ends_at}:
        {stage:'off',ok:true,schema:1,revision:value.revision,server_time:value.ends_at,ends_at:null};
      announce(next);plan(next,overdue);refresh();
    };
    expiryTimer=setTimeout(()=>{
      if(performance.now()<boundaryAt){plan(value,elapsed+performance.now()-startedPlan);return;}
      onBoundary?.();
    },Math.max(1,Math.min(2147483647,remaining)));
  }
  async function refresh(){
    if(busy)return;
    busy=true;
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),3000);
    const before=version,started=performance.now();
    try{
      const response=await fetch(endpoint,{cache:'no-store',credentials:'omit',signal:controller.signal});
      if(!response.ok)throw Error();
      const next=await response.json();if(!valid(next))throw Error();
      const fresh={...next};
      if(before===version){
        const elapsed=performance.now()-started;
        if(fresh.ends_at&&Date.parse(fresh.ends_at)-Date.parse(fresh.server_time)<=elapsed){
          plan(fresh,elapsed);
        }else {announce(fresh);plan(fresh,elapsed);}
      }
      else setTimeout(refresh,0);
    }catch{
      // Fail closed; the original Shopify theme is always a complete fallback.
      clearTimeout(timer);clearTimeout(expiryTimer);boundaryAt=Infinity;onBoundary=null;announce({stage:'off'});timer=setTimeout(refresh,60000);
    }finally{clearTimeout(timeout);busy=false;}
  }
  window.KobStorefrontColourPolicy={ready,refresh,get current(){return policy;}};
  function resume(){if(performance.now()>=boundaryAt)onBoundary?.();refresh();}
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)resume();});
  window.addEventListener('pageshow',e=>{if(e.persisted)resume();});
  refresh();
})();
